import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYonetimKullaniciKart_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYonetimKullaniciKart_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Get_Helpers_LoginUserInfo: any[];
  Get_Helpers_LoginUserInfo_dummy: any[];
  Get_Yonetim_FirmaListe: any[];
  Get_Yonetim_FirmaListe_dummy: any[];
  Get_Helpers_RoleList: any[];
  Get_Helpers_RoleList_dummy: any[];
  Get_Yonetim_KullaniciById: any[];
  Get_Yonetim_KullaniciById_dummy: any[];
  Get_Tanim_MusteriTedarikciListe: any[];
  Get_Tanim_MusteriTedarikciListe_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  SaveUser: any;
  SaveUser_dummy: any;
  Add_Yonetim_KullaniciFirma: number;
  Add_Yonetim_KullaniciFirma_dummy: number;
  isComp742500Visible: "visible" | "hidden";
}

export class YonetimKullaniciKart_ScreenBase extends React.PureComponent<
  IYonetimKullaniciKart_ScreenProps,
  any
> {
  yonetimkullanicikart_128337_value_kuikaSelectBoxRef: React.RefObject<any>;
  yonetimkullanicikart_810791_value_kuikaSelectBoxRef: React.RefObject<any>;
  yonetimkullanicikart_988389_value_kuikaAutoCompleteRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "126f998b-60d5-4366-ab48-bd4d3da4f842",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 891214,
          PropertyName: "value",
          Value: "KULLANICI EKLEME - DÜZENLEME",
        },
        { Id: 48474, PropertyName: "value", Value: "Kullanıcı Adı" },
        { Id: 198377, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 767051, PropertyName: "value", Value: "Parola" },
        { Id: 607530, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 684043, PropertyName: "value", Value: "Ad" },
        { Id: 249909, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 172445, PropertyName: "value", Value: "Soyad" },
        { Id: 742449, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 125168, PropertyName: "value", Value: "Rol" },
        { Id: 128337, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 249608, PropertyName: "value", Value: "Firma" },
        { Id: 810791, PropertyName: "placeholder", Value: "Choose one..." },
        {
          Id: 539710,
          PropertyName: "value",
          Value: "Bağlı Olduğu Müşteri-Tedarikçi",
        },
        { Id: 988389, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 974814, PropertyName: "label", Value: "Vazgeç" },
        { Id: 865072, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yonetimkullanicikart_198377_value_kuikaTextInputRef =
      React.createRef();
    this.yonetimkullanicikart_607530_value_kuikaTextInputRef =
      React.createRef();
    this.yonetimkullanicikart_249909_value_kuikaTextInputRef =
      React.createRef();
    this.yonetimkullanicikart_742449_value_kuikaTextInputRef =
      React.createRef();
    this.yonetimkullanicikart_128337_value_kuikaSelectBoxRef =
      React.createRef();
    this.yonetimkullanicikart_810791_value_kuikaSelectBoxRef =
      React.createRef();
    this.yonetimkullanicikart_988389_value_kuikaAutoCompleteRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Get_Helpers_LoginUserInfo: [],
      Get_Yonetim_FirmaListe: [],
      Get_Helpers_RoleList: [],
      Get_Yonetim_KullaniciById: [],
      Get_Tanim_MusteriTedarikciListe: [],
      GoBack: "",
      SaveUser: "",
      Add_Yonetim_KullaniciFirma: 0,
      isComp742500Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yonetimkullanicikart", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YonetimKullaniciKartPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yonetimkullanicikart", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yonetimkullanicikart", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YonetimKullaniciKartPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yonetimkullanicikart_198377_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.userName ?? undefined,
      yonetimkullanicikart_249909_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.firstName ?? undefined,
      yonetimkullanicikart_742449_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.lastName ?? undefined,
      yonetimkullanicikart_128337_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.kRole_Id ?? undefined,
      yonetimkullanicikart_810791_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.firmaId ?? undefined,
      yonetimkullanicikart_988389_value:
        this.state.Get_Yonetim_KullaniciById?.at?.(0)?.bagliFirmaId ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YonetimKullaniciKartPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      UserId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_LoginUserInfo !== undefined
            ? stateVars.Get_Helpers_LoginUserInfo?.length > 0
              ? stateVars.Get_Helpers_LoginUserInfo[0].id
              : null
            : this.state.Get_Helpers_LoginUserInfo?.length > 0
            ? this.state.Get_Helpers_LoginUserInfo[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimKullaniciKart/YonetimKullaniciKartPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_LoginUserInfo =
      result?.data.get_Helpers_LoginUserInfo;
    stateVars.Get_Yonetim_FirmaListe = result?.data.get_Yonetim_FirmaListe;

    formVars.yonetimkullanicikart_810791_options =
      stateVars.Get_Yonetim_FirmaListe;
    stateVars.Get_Helpers_RoleList = result?.data.get_Helpers_RoleList;

    formVars.yonetimkullanicikart_128337_options =
      stateVars.Get_Helpers_RoleList;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YonetimKullaniciKartPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YonetimKullaniciKart/YonetimKullaniciKartPageInit1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.Get_Yonetim_KullaniciById =
        result?.data.get_Yonetim_KullaniciById;
      formVars.yonetimkullanicikart_198377_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].userName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].userName
            : null
        );
      formVars.yonetimkullanicikart_249909_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].firstName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].firstName
            : null
        );
      formVars.yonetimkullanicikart_742449_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].lastName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].lastName
            : null
        );
      formVars.yonetimkullanicikart_128337_value =
        stateVars.Get_Yonetim_KullaniciById !== undefined
          ? stateVars.Get_Yonetim_KullaniciById?.length > 0
            ? stateVars.Get_Yonetim_KullaniciById[0].kRole_Id
            : null
          : this.state.Get_Yonetim_KullaniciById?.length > 0
          ? this.state.Get_Yonetim_KullaniciById[0].kRole_Id
          : null;
      formVars.yonetimkullanicikart_810791_value =
        stateVars.Get_Yonetim_KullaniciById !== undefined
          ? stateVars.Get_Yonetim_KullaniciById?.length > 0
            ? stateVars.Get_Yonetim_KullaniciById[0].firmaId
            : null
          : this.state.Get_Yonetim_KullaniciById?.length > 0
          ? this.state.Get_Yonetim_KullaniciById[0].firmaId
          : null;
      formVars.yonetimkullanicikart_988389_value =
        stateVars.Get_Yonetim_KullaniciById !== undefined
          ? stateVars.Get_Yonetim_KullaniciById?.length > 0
            ? stateVars.Get_Yonetim_KullaniciById[0].bagliFirmaId
            : null
          : this.state.Get_Yonetim_KullaniciById?.length > 0
          ? this.state.Get_Yonetim_KullaniciById[0].bagliFirmaId
          : null;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_LoginUserInfo !== undefined
            ? stateVars.Get_Helpers_LoginUserInfo?.length > 0
              ? stateVars.Get_Helpers_LoginUserInfo[0].id
              : null
            : this.state.Get_Helpers_LoginUserInfo?.length > 0
            ? this.state.Get_Helpers_LoginUserInfo[0].id
            : null
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimKullaniciKart/YonetimKullaniciKartPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Tanim_MusteriTedarikciListe =
      result?.data.get_Tanim_MusteriTedarikciListe;

    formVars.yonetimkullanicikart_988389_options =
      stateVars.Get_Tanim_MusteriTedarikciListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YonetimKullaniciKartPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullanicikart_198377_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].userName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].userName
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp742500Visible =
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YonetimKullaniciKartPageInit5_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullanicikart_249909_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].firstName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].firstName
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullanicikart_742449_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].lastName
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].lastName
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullanicikart_128337_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].kRole_Id
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].kRole_Id
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_128337 =
      stateVars.Get_Helpers_RoleList ?? this.state.Get_Helpers_RoleList;
    stateVars.dataSource_128337 =
      stateVars.Get_Helpers_RoleList ?? this.state.Get_Helpers_RoleList;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YonetimKullaniciKartPageInit9_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullanicikart_810791_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].firmaId
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].firmaId
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_810791 =
      stateVars.Get_Yonetim_FirmaListe ?? this.state.Get_Yonetim_FirmaListe;
    stateVars.dataSource_810791 =
      stateVars.Get_Yonetim_FirmaListe ?? this.state.Get_Yonetim_FirmaListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YonetimKullaniciKartPageInit11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.KullaniciId ??
          this.props.screenInputs.kullaniciid,
        "00000000-0000-0000-0000-000000000000"
      )
    ) {
      formVars.yonetimkullanicikart_988389_value =
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Yonetim_KullaniciById !== undefined
            ? stateVars.Get_Yonetim_KullaniciById?.length > 0
              ? stateVars.Get_Yonetim_KullaniciById[0].bagliFirmaId
              : null
            : this.state.Get_Yonetim_KullaniciById?.length > 0
            ? this.state.Get_Yonetim_KullaniciById[0].bagliFirmaId
            : null
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.YonetimKullaniciKartPageInit12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YonetimKullaniciKartPageInit12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_988389 =
      stateVars.Get_Tanim_MusteriTedarikciListe ??
      this.state.Get_Tanim_MusteriTedarikciListe;
    stateVars.dataSource_988389 =
      stateVars.Get_Tanim_MusteriTedarikciListe ??
      this.state.Get_Tanim_MusteriTedarikciListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YonetimKullaniciKartComponent_810791_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_LoginUserInfo !== undefined
            ? stateVars.Get_Helpers_LoginUserInfo?.length > 0
              ? stateVars.Get_Helpers_LoginUserInfo[0].id
              : null
            : this.state.Get_Helpers_LoginUserInfo?.length > 0
            ? this.state.Get_Helpers_LoginUserInfo[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimKullaniciKart/YonetimKullaniciKartComponent_810791_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Tanim_MusteriTedarikciListe =
      result?.data.get_Tanim_MusteriTedarikciListe;

    formVars.yonetimkullanicikart_988389_options =
      stateVars.Get_Tanim_MusteriTedarikciListe;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YonetimKullaniciKartComponent_810791_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciKartComponent_810791_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_988389 =
      stateVars.Get_Tanim_MusteriTedarikciListe ??
      this.state.Get_Tanim_MusteriTedarikciListe;
    stateVars.dataSource_988389 =
      stateVars.Get_Tanim_MusteriTedarikciListe ??
      this.state.Get_Tanim_MusteriTedarikciListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YonetimKullaniciKartComponent_974814_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "43fc490a_712c_ab21_16b0_3731dcc99abb_confirmation",
        this.defaultML,
        "Kayıt edilmeyen veriler iptal edilecek"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YonetimKullaniciKartComponent_865072_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      userName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullanicikart_198377_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      firstName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullanicikart_249909_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      lastName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullanicikart_742449_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      roleNames_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullanicikart_128337_value",
            "value",
            "Get_Helpers_RoleList",
            "id",
            "rolAdi"
          )
        ),
        "string"
      ),
      startingScreenId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "a108361e-337a-4c88-b20f-69b5eebcd23a",
          "Guid"
        ),
        "Guid"
      ),
      phoneNumber_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dontSendEmail_0: ReactSystemFunctions.convertToTypeByName(
        true,
        "boolean"
      ),
      twoFactorAuthenticationType_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "number"
      ),
      KullaniciId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.SaveUser?.id),
        "Guid"
      ),
      FirmaId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullanicikart_810791_value",
            "value",
            "Get_Yonetim_FirmaListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BagliFirmaId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yonetimkullanicikart_988389_value",
            "value",
            "Get_Tanim_MusteriTedarikciListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YonetimKullaniciKart/YonetimKullaniciKartComponent_865072_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveUser = result?.data.saveUser;
    stateVars.Add_Yonetim_KullaniciFirma =
      result?.data.add_Yonetim_KullaniciFirma;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YonetimKullaniciKartComponent_865072_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YonetimKullaniciKartComponent_865072_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YonetimKullaniciKartPageInit();
    }
  }
}
